export class MultipleImageHelper {
    static readonly JSON_IMAGES = [
        '_id',
        //face
        'face-1',
        'face-2',
        'face-3',
        'face-4',
        'face-5',
        'face-6',
        'face-all',
        //other
        'other-1',
        'other-2',
        'other-3',
        'other-4',
        'other-5',
        'other-6',
        'other-all',
        //movie
        'movie-1',
        'movie-2',
        'movie-3',
        'movie-4',
        'movie-5',
        'movie-6',
        'movie-all',
        //xp
        'xp-1',
        'xp-2',
        'xp-3',
        'xp-4',
        'xp-5',
        'xp-6',
        'xp-all',
        //tooth
        'tooth-right',
        'tooth-front',
        'tooth-left',
        'tooth-upper',
        'tooth-overjet',
        'tooth-lower',
        'tooth-all',
        //aligner
        'aligner-right',
        'aligner-front',
        'aligner-left',
        'aligner-upper',
        'aligner-overjet',
        'aligner-lower',
        'aligner-all',
    ]

    static JSON_DEFAULT = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

    static parseClientInitJson(currentValue = {}, json: any = {}) {
        const clientVisitImages = currentValue
        this.JSON_IMAGES.forEach((item) => {
            clientVisitImages[item] = (json[item] != undefined) ? json[item] : this.JSON_DEFAULT
        })

        return clientVisitImages
    }

    static POSITION_TYPES = [
        'right',
        'front',
        'left',
        'upper',
        'overjet',
        'lower',
    ]

    /**
     * Get relation of registration image
     */
    static getRelationRegistrationImage(positionName = 'tooth-all', imageIndex = 0): IImageRelationPosition[] {
        let results: IImageRelationPosition[] = []
        if (positionName.indexOf('-') > 0 && imageIndex < 12) {
            results = [{ position: positionName, index: imageIndex }]
            const [type, position] = positionName.split('-')
            const positionPrefix = type + '-'
            if (position == 'all') {
                const positionTypeField = (type == 'aligner' || type == 'tooth') ? this.POSITION_TYPES[imageIndex] : (imageIndex + 1)
                results[1] = { position: positionPrefix + positionTypeField, index: 0 }
            } else if (imageIndex == 0) {
                let allIndex = 0
                if (type == 'aligner' || type == 'tooth') {
                    // 'right', 'front', 'left', 'upper', 'overjet', 'lower'
                    allIndex = this.POSITION_TYPES.findIndex((item) => {
                        return item == position
                    })
                } else {
                    // 1-> 6
                    allIndex = parseInt(position, 10) - 1
                }
                results[1] = { position: positionPrefix + 'all', index: allIndex }
            }

        }

        return results
    }
}

export interface IImageRelationPosition {
    position: string;
    index: number;
}



// WEBPACK FOOTER //
// ./src/helper/mutiple-image.helper.ts